import {
    Component,
    EventEmitter,
    OnChanges,
    Input,
    Output,
    ElementRef,
    AfterViewInit,
    OnDestroy,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import DesignerPaper from '../../designer-app/src/designer-ui/components/designer-paper/designer-paper.component';
import { DomUtils } from '../dom/dom-utils';

import { SVG2Bitmap, dataURLtoBlob, base64toBlob } from './svg-export';

let fileSaver = require('file-saver');

let joint = require('jointjs');
let $ = require('jquery');
let svgpanzoom = require('svg-pan-zoom');
let _ = require('lodash');


const ALLOW_AREA_HIGHLIGHT: boolean = false;

@Component({
    selector: 'vca-joint',
    template: require('./vca-joint.html'),
    styles: [require('./vca-joint.scss')],
    encapsulation: ViewEncapsulation.None
})
export class VcaJoint implements OnChanges {

    @Input() public elements: any;
    @Input() public tips: any;
    @Input() public graphTips: any;
    @Input() allowAreaHighlight: boolean = ALLOW_AREA_HIGHLIGHT
    @Output() onZoom = new EventEmitter<any>();
    @Output() onPan = new EventEmitter<any>();
    @Output() onAdd = new EventEmitter<any>();
    @Output() onRemove = new EventEmitter<any>();
    @Output() onCellClick = new EventEmitter<any>();
    @Output() onBlankAreaClick = new EventEmitter<any>();
    @Output() onCellMouseEnter = new EventEmitter<any>();
    @Output() onCellMouseExit = new EventEmitter<any>();
    @Output() onAreaResize = new EventEmitter<any>();
    @Output() onCellRightClick = new EventEmitter<any>();
    @Output() onBlankRightClick = new EventEmitter<any>();
    @Output() onEscPress = new EventEmitter<any>();

    /**
     * Event to let update our graph with new coordinates
     * of the cell/element. We need this for positioning
     * if the container object moved from its location.
     */
    @Output() onCellMoveEvent = new EventEmitter<any>();

    graph: any;
    paper: any;
    options: any;

    tempPaper: any;
    tempGraph: any;
    tempOptions: any;
    exportSvgPanZoom: any;

    svgPanZoom: any;
    overlayContainer: HTMLDivElement;
    @ViewChild('graphOverlay') containerViewChild: ElementRef;

    //private isCellMoving = false;

    private grabEnabled = true;

    constructor(public dom: DomUtils) {

    }

    public ngOnChanges(changes): any {
        // TODO In case of auto refresh, this might be called more frequentlty, leading
        // to a pile-up of stale graphs.
        this.render();
    }

    ngAfterViewInit() {
        this.overlayContainer = <HTMLDivElement> this.containerViewChild.nativeElement;
    }

    public exportGraph(filename: string)  {
        let params = {'backgroundColor': '#FFFFFF', 'scale': 5, 'quality': 1, 'full': false};
        let fullExportNode = $('#export-paper')[0].childNodes[2];
        // Do not pass full = true here as we do not use that anymore
        SVG2Bitmap(fullExportNode, function (canvas, dataURL) {
            let imgBlob = dataURLtoBlob(dataURL);
            fileSaver.saveAs(imgBlob, filename);
        }, params);
    }

    public render() {
        if (this.graph) {
            this.graph.clear();
        }
        this.graph = new joint.dia.Graph;
        this.options = {
            el: $('#paper'),
            gridSize: 1,
            interactive: {vertexAdd: false},
            model: this.graph
        };

        this.paper = new joint.dia.Paper(this.options);

        // Setting paper origin at the center of the screen.

        this.paper.translate($('#paper').width() * 0.5, $('#paper').height() * 0.5);

        this.addElements(this.elements);

        this.definePaperEvents();
        this.defineGraphEvents();

        let targetElement = $('#paper')[0];

        this.svgPanZoom = svgpanzoom(targetElement.childNodes[2],
            {
                viewportSelector: targetElement.childNodes[2].childNodes[0],
                fit: true,
                center: true,
                panEnabled: true,
                minZoom: 0.2,
                maxZoom: 4,
                zoomScaleSensitivity: 0.5
            });

        this.svgPanZoom.setOnZoom((level) => {
            this.onZoom.emit(level);
            if (level < 0.4) {
                $('text').hide();
            } else {
                $('text').show();
            }
        });


        this.tempGraph = new joint.dia.Graph;
        this.tempOptions = {
            el: $('#export-paper'),
            gridSize: 1,
            interactive: {vertexAdd: false},
            model: this.tempGraph
        };
        this.tempPaper = new joint.dia.Paper(this.tempOptions);
        this.tempPaper.translate($('#export-paper').width() * 0.5, $('#export-paper').height() * 0.5);
        this.exportSvgPanZoom = svgpanzoom($('#export-paper')[0].childNodes[2], {
            viewportSelector: $('#export-paper')[0].childNodes[2].childNodes[0],
            fit: false,
            panEnabled: true,
            minZoom: 0.2,
            maxZoom: 4,
            zoom: 1,
            zoomScaleSensitivity: 0.5
        });
        this.exportSvgPanZoom.zoomBy(0.5);

        let vcaJoint = this;

        $(document).keyup(function (event) {
            let escapePressed = (event.which === 27); // 27 is for ESC key.
            if (escapePressed) {
                vcaJoint.onEscPress.emit();
            }
        });

    }

    /**
     *
     * @param elements Must be an Array of JointJS Elements
     */
    public addElements(elements: any[], isInteractiveAdd: boolean = false) {
        this.graph.addCells(elements);

        if (isInteractiveAdd && elements.length === 1) {
            // Unhighlight all and highlight the newly added node only if not 'area'
            $('.custom-highlight-class').removeClass('custom-highlight-class');
            if (elements[0].attributes.type != 'area' &&
                elements[0].attributes.type !== 'customLink' &&
                elements[0].attributes.type !== 'connection') {
                $('[model-id="' + elements[0].id + '"] .highlight-component').addClass("custom-highlight-class");
            }
        }

        this.onAdd.emit(elements);
    }

    /**
     *
     * @param cell
     * @param params If the flag 'resize' is set to true, the movement restriction is not enforced.
     * The caller itself must ensure the parent's boundaries are expanded sufficiently,
     * so the moving child fits in (by calling node.component.ts # resizeAfterEmbed).
     */
    positionChanged(cell, params) {
        // Restricting the child moment to the parent boundaries.
        let parentId = cell.get('parent');
        if (!parentId) return;

        let parent = this.graph.getCell(parentId);
        let parentBbox = parent.getBBox();
        let cellBbox = cell.getBBox();

        if (parentBbox.containsPoint(cellBbox.origin()) &&
            parentBbox.containsPoint(cellBbox.topRight()) &&
            parentBbox.containsPoint(cellBbox.corner()) &&
            parentBbox.containsPoint(cellBbox.bottomLeft())) {
            cell.attributes.isCellMoving = true;
            /*
             * If the four corners of the child cell's bounding box are inside parent's bbox,
             * do nothing.
             * Otherwise, set it's position to previous position.
             */
            return;
        } else if (params && params.hasOwnProperty('resize') && params.resize === true) {
            /*
             * If the flag 'resize' is set to true, the movement restriction is not enforced.
             * The caller itself must ensure the parent's boundaries are expanded sufficiently,
             * so the moving child fits in (by calling node.component.ts # resizeAfterEmbed).
             */
            return;
        } else if (params && params.hasOwnProperty('overrideGrab') && params.overrideGrab === true) {
            return;
        }

        cell.set('position', cell.previous('position'));
    }

    private getPosition(event) {
        if (event) {
            event.preventDefault();
            let left = event.pageX + 1;
            let top = event.pageY + 1;
            let width = this.overlayContainer.offsetParent ? this.overlayContainer.offsetWidth :
                this.dom.getHiddenElementOuterWidth(this.overlayContainer);
            let height = this.overlayContainer.offsetParent ? this.overlayContainer.offsetHeight :
                this.dom.getHiddenElementOuterHeight(this.overlayContainer);
            let viewport = this.dom.getViewport();
            if (left + width - document.body.scrollLeft > viewport.width) {
                left -= width;
            }
            if (top + height - document.body.scrollTop > viewport.height) {
                top -= height;
            }
            if (left < document.body.scrollLeft) {
                left = document.body.scrollLeft;
            }
            if (top < document.body.scrollTop) {
                top = document.body.scrollTop;
            }
            if (event.pageX > 0 && left === 0) {
                left = event.pageX + 1;
            }
            return {'left': left, 'top': top};
        }
    }

    private definePaperEvents() {
        let vca_joint_context = this;
        this.paper.on('cell:pointerclick', (cellView, event, x, y) => {
            let isElementSelected: boolean;
            _.each(vca_joint_context.paper.model.getCells(), function (cell) {
                if (cell.id === cellView.model.id) {
                    isElementSelected = (ALLOW_AREA_HIGHLIGHT ||
                        cell.attributes.type != 'area') &&
                                cell.isElement();

                }
            });

            if (cellView.model.attributes.type === 'customLink') {
                let isShadow:boolean = cellView.model.attributes.isShadow;
                if(!isShadow) {
                    vca_joint_context.graphTips.forEach(tip => {
                        let customEvent = {cellAttributes: cellView.model.attributes, cellEvent: event};
                        let selector = tip.selector;
                        if ('customLink' === selector) {
                            if (event) {
                                let html = tip.content.apply(tip.context, [customEvent]);
                                let $tooltip = $('#graph-overlay');
                                $tooltip.html(html);
                                let position = vca_joint_context.getPosition(event);
                                $tooltip.css({position: 'fixed', 'top': position.top + 5, 'left': position.left - 100});
                                $tooltip.show();
                            }
                        } else {
                            return;
                        }
                    });
                }
            } else {
                let isShadow:boolean = cellView.model.attributes.isShadow;
                let shadowMapped:boolean = cellView.model.attributes.shadowDetails && cellView.model.attributes.shadowDetails.boundTo;

                // Unhighlight all the other elements first.
                $('.custom-highlight-class').removeClass('custom-highlight-class');

                // Highlight the selected cell if it only and element and not link.
                if (isElementSelected) {
                    if (isShadow && shadowMapped) {
                        $('[model-id="' + cellView.model.attributes.shadowDetails.boundTo.element.id + '"] .highlight-component').addClass('custom-highlight-class');
                    } else if(isShadow) {
                        // Don't highlight umbound shadow
                    } else {
                        $('[model-id="' + cellView.model.id + '"] .highlight-component').addClass('custom-highlight-class');
                    }
                }

                if(isElementSelected && isShadow && shadowMapped) {
                    this.onCellClick.emit(cellView.model.attributes.shadowDetails.boundTo.element.attributes);
                } else {
                    this.onCellClick.emit(cellView.model.attributes);
                }
            }
        });


        this.paper.on('blank:pointerclick', (event, x, y) => {
            let vca_joint_context = this;

            //Unhighlight all the elements when clicked on blank area.
            $(".custom-highlight-class").removeClass("custom-highlight-class");

            let $tooltip = $('.graph-tooltip');
            $tooltip.hide();
            this.onBlankAreaClick.emit();
        });

        this.paper.on('cell:pointerdown', (cellView, event, x, y) => {
            // Disable panning when the mouse is down on a cell
            this.svgPanZoom.disablePan();
        });

        this.paper.on('blank:pointerdown', (event, x, y) => {
            // Enable panning when the mouse is down on a blank area
            this.svgPanZoom.enablePan();
        });

        this.paper.on('cell:pointerup', (cellView, event, x, y) => {
            // Enable panning when the mouse is up on a cell
            this.svgPanZoom.enablePan();
            // Also bubble up event if a cell was dragged to another position
            if (cellView.model.attributes.isCellMoving) {
                // cellView.model === cell
                cellView.model.attributes.isCellMoving = false;
                //console.debug(">>>> Cell Moved To: " + cellView.model.attributes.id + " x=" + x + " y=" + y);
                this.onCellMoveEvent.emit(
                    {
                        cellAttributes: cellView.model.attributes,
                        position: {x: x, y: y},
                    }
                );
            }
        });

        this.paper.on('blank:pointerup', (event, x, y) => {
            // Disable panning when the mouse is up on a blank area
            this.svgPanZoom.disablePan();
            //this.isCellMoving = false;
        });

        var timeoutid = null;

        this.paper.on('cell:mouseenter', (cellView, event) => {
            let $tooltip = $('#hcx-designer-tooltip');
            $tooltip.hide();
            let type = cellView.model.attributes.type;
            if (event.target.href != undefined) {
                if (event.target.href.animVal.includes('dps.svg') ||
                    event.target.href.animVal.includes('dr.svg') ||
                    event.target.href.animVal.includes('hybrid-interconnect.svg')) {
                    type = event.target.className.animVal;
                }
            }
            let toolTipText: String;
            vca_joint_context.tips.forEach(tip => {
                let customEvent = {cellAttributes: cellView.model.attributes, cellEvent: event};
                let width = cellView.model.attributes.width;
                let height = cellView.model.attributes.height;
                let selector = tip.selector;
                if (type === selector) {
                    try {
                        toolTipText = tip.content.apply(tip.context, [customEvent]);
                        if (toolTipText) {
                            timeoutid = setTimeout(function () {
                                $tooltip.html('<span>' + toolTipText + '</span>');
                                let position = vca_joint_context.getPosition(event);
                                $tooltip.css({position: "fixed", 'top': position.top + 5, 'left': position.left + 5});
                                $tooltip.show();
                            }, 500);
                        } else {
                            //console.debug("Could not show tooltip - empty data.");
                        }
                    } catch (e) {
                        //console.debug("Could not show tooltip - no data.", e);
                    }
                } else {
                    return;
                }

            });
        });

        this.paper.on('cell:mouseleave', (cellView, event) => {
            clearTimeout(timeoutid);
            let $tooltip = $('.hcx-designer-tooltip');
            $tooltip.hide();
        });

        this.paper.on('cell:contextmenu', (cellView, event, x, y) => {
            // Right click on a cell.
            let options = {
                'cell' : cellView,
                'event': event,
                'x': x,
                'y': y
            };
            this.onCellRightClick.emit(options);
        });

        this.paper.on('blank:contextmenu', (event, x, y) =>{
            // Right click on a blank area.
            let options = {
                'event': event,
                'x': x,
                'y': y
            };
            this.onBlankRightClick.emit(options);
        });
    }

    public closeTip() {
        let $tooltip = $('.graph-tooltip');
        $tooltip.hide();
    }

    private defineGraphEvents() {

        this.graph.on('change:size', (element, size, opts) => {
            opts.size = size;
            opts.position = element.attributes.position;
            opts.parent = element.attributes.parent;
            opts.type = element.attributes.type;
            this.onAreaResize.emit(opts);
            //console.debug("Area Resized: ", opts);
        });

        this.graph.on('change:position', (cell, position, params) => {
            if (this.grabEnabled || (params && params.hasOwnProperty('overrideGrab') && params.overrideGrab === true)) {
                this.positionChanged(cell, params);
                let vca_joint_context = this;

                // Update links when a cell's position is changed.
                _.each(vca_joint_context.graph.getLinks(), function (link) {
                    let linkView = vca_joint_context.paper.findViewByModel(link);
                    linkView.update();
                })
            } else {
                cell.set('position', cell.previous('position'));
            }
        });

        this.graph.on('add', (cell) => {
            let vca_joint_context = this;

            // Update links when a cell is added.
            _.each(vca_joint_context.graph.getLinks(), function (link) {
                let linkView = vca_joint_context.paper.findViewByModel(link);
                linkView.update();
            });

            if(cell.isElement()) {
                // Panning to the center of the newly added element.
                // This will prevent details pane covering the newly added element.

                let cellCenter = cell.getBBox().center();
                vca_joint_context.svgPanZoom.pan({x: 0, y: 0});

                let sizes = vca_joint_context.svgPanZoom.getSizes();
                let realZoom = sizes.realZoom;
                vca_joint_context.svgPanZoom.pan
                ({
                    x: -(cellCenter.x * realZoom) + (sizes.width / 2),
                    y: -(cellCenter.y * realZoom) + (sizes.height / 2)
                });

                // Panning ends.
            }

            //console.debug('element added');

        });

    }

    private zoomIn() {
        this.svgPanZoom.zoomIn();
    };

    private zoomOut() {
        this.svgPanZoom.zoomOut();
    };

    private resetPanZoom() {
        this.svgPanZoom.reset();
    }

    // Below methods are used to demonstrate the element selection ways.
    // One method can be used to select a specific element given it's id.
    // One method is used to select an element of give type. (Router is this example).
    public dimAllRouters() {
        $('.router').addClass("dim-element-class");
    }

    public reduceOpacityById(id: string) {
        $('[model-id="' + id + '"]').addClass("dim-element-class");
    }

    public restoreOpacityById(id: string) {
        $('[model-id="' + id + '"]').removeClass("dim-element-class");
    }

    setGrab(grabEnabled: boolean) {
        this.grabEnabled = grabEnabled;
    }

    exportElementsAndLinks() {
        // Export existing state of graph
        let oldCells = this.graph.getCells();
        let cellsToClone = [];
        for(const cell of oldCells) {
            if(!(cell.attributes.type === 'virtualarea')) {
                cellsToClone.push(cell);
            }
        }
        let clones = this.graph.cloneCells(cellsToClone);
        // Import to Graph below the hidden div
        this.tempGraph.clear();
        for (let key in clones) {
            this.tempGraph.addCell(clones[key]);
        }
        this.exportSvgPanZoom.updateBBox();
        this.exportSvgPanZoom.resize();
        this.exportSvgPanZoom.fit();
        this.exportSvgPanZoom.center();
        this.exportSvgPanZoom.zoomBy(0.90);
    }

    public exportAsImage(details) {
        let params = {'backgroundColor': '#FFFFFF', 'scale': 5, 'quality': 1, 'full': false};
        // Export the existing graph and plot in the hidden div
        if (details.fullOrVisible && details.fullOrVisible === 'visible') {
            let svgNode = $('#paper')[0].childNodes[2];
            params.full = false;
            SVG2Bitmap(svgNode, function (canvas, dataURL) {
                let imgBlob = dataURLtoBlob(dataURL);
                fileSaver.saveAs(imgBlob, details.fileName || 'graph');
            }, params);
        } else if (details.fullOrVisible && details.fullOrVisible === 'full') {
            this.exportElementsAndLinks();
            setTimeout(()=>{this.exportGraph(details.fileName || 'graph')},1000);
        }
    }
}




// WEBPACK FOOTER //
// ./src/common/vca-joint/vca-joint.component.ts